import { render, staticRenderFns } from "./chatDrawer.vue?vue&type=template&id=cf1bf824&scoped=true&"
import script from "./chatDrawer.vue?vue&type=script&lang=js&"
export * from "./chatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./chatDrawer.vue?vue&type=style&index=0&id=cf1bf824&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1bf824",
  null
  
)

export default component.exports